import { makeVar } from '@apollo/client';
import { HandleError } from 'models';

export const ErrorStateInitialState: HandleError = {
  errorState: undefined,
};

export const ErrorState = makeVar<HandleError>(ErrorStateInitialState);
